import React from 'react';
import styled, { css } from 'styled-components';

const searchIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/searchIcon.svg';

const Container = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 32px;

    h3 {
      margin-top: 16px;
      font-weight: ${theme.fontWeight.medium};
      font-size: 16px;
      color: ${theme.colors.colorGray400};
      text-align: center;
    }
  `}
`;

type EmptyListProps = {
  visible: boolean;
  info: string;
};

export const EmptyList: React.FC<EmptyListProps> = ({ visible, info }) => {
  return (
    <>
      {visible && (
        <Container>
          <img src={searchIcon} alt="search icon" />
          <h3>{info}</h3>
        </Container>
      )}
    </>
  );
};
